// extracted by mini-css-extract-plugin
module.exports = {"container":"AwardContent_container__B1qko"};